import { render, staticRenderFns } from "./MChangePassword.vue?vue&type=template&id=6a4a2fac&"
import script from "./MChangePassword.vue?vue&type=script&lang=js&"
export * from "./MChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./MChangePassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports